import { Component } from '@angular/core';
import { NavController,App,LoadingController,ItemSliding,ToastController} from 'ionic-angular';
import { MessageDetail } from '../detail/detail';
import { StorageService } from '../../../providers/service/storageservice';
import { AppState } from '../../../app/app.global';
import { HttpService } from '../../../providers/service/httpservice';
import { SELECT_MSG_CATEGORY,MARK_MSG_BY_CATEGORYID} from '../../../providers/config/serviceurl';
import { LoginPage } from '../../login/login/login';
import { BrowserPage } from '../../comm/browser/browser';
import {MsgSettingPage} from '../msg-setting/msg-setting';
import {XxtxmsglistPage} from '../xxtxmsglist/xxtxmsglist';
import {WddbmsglistPage} from '../wddbmsglist/wddbmsglist';
import {Utils} from '../../../providers/service/utils';

@Component({
  selector: 'message-list-page',
  templateUrl: 'list.html'
})
export class MessageListPage {
	msgdata:any=[];//消息展示
	msgTypes:any = [];//消息类型
	msgState:any = [];//消息设置是否展示
	user:any;
	msgsignUnRead:any = [];//标记未读缓存消息分类ID值
	msgdelteItem:any = [];//删除缓存消息分类ID值
	
	constructor(public navCtrl: NavController,public appCtrl: App,
		private loadCtrl:LoadingController,private httpService:HttpService,
		public toastCtrl: ToastController,public global: AppState) {
		this.user = StorageService.getObj('currentUser');
		if(!Utils.isLogined()){
			this.appCtrl.getRootNav().push(LoginPage);
		}
	}

	ionViewWillEnter(){
		if(Utils.isLogined()){
			this.dataInit();
		}
	}

	dataInit() {
		if(localStorage.getItem('msgSettingListCache') && localStorage.getItem('msgSettingListCache')!= null && localStorage.getItem('msgSettingListCache')!= ""){
			this.msgState = JSON.parse(localStorage.getItem('msgSettingListCache'));
		}else{
			this.msgState = []
		}

		if(localStorage.getItem('msgsignUnRead')!= undefined && localStorage.getItem('msgsignUnRead')!= null && localStorage.getItem('msgsignUnRead')!= ""){
			this.msgsignUnRead = JSON.parse(localStorage.getItem('msgsignUnRead'));
		}else{
			this.msgsignUnRead = []
		}

		if(localStorage.getItem('msgdelteItem') && localStorage.getItem('msgdelteItem')!= null && localStorage.getItem('msgdelteItem')!= ""){
			this.msgdelteItem = JSON.parse(localStorage.getItem('msgdelteItem'));
		}else{
			this.msgdelteItem = []
		}

		this.msgdata = [];
		this.getMsgTypes();
	}

	getMsgTypes(){
		let params = {'username':this.user.xgh};
		this.httpService.get2(SELECT_MSG_CATEGORY,params).then(anyObj =>this.handlegetMsgTypes(anyObj));
	}

	handlegetMsgTypes(obj:any){
		this.msgdata = [];
		if(obj != null && obj != undefined && obj.items != null && obj.items != undefined){
		  this.msgTypes = obj.items;
		  console.log(JSON.stringify(this.msgTypes));
		  for (let index = 0; index < this.msgTypes.length; index++) {
			let categoryId = this.msgTypes[index].ID;

			let name = this.msgTypes[index].NAME; 

			let unreadCount = this.msgTypes[index].COUNT;

			let time = this.renderTime(this.msgTypes[index].SEND_TIME); // 日期转换

			console.log('time === ' + time);

			let content = this.getALabelContent(this.msgTypes[index].CONTENT); // 获取a标签里的内容（例：<a href=''>测试</a>）

			let code = this.msgTypes[index].CODE;
			if(this.msgState != null && this.msgState.constructor ==Array && this.msgState.length > 0){//是否显示该分类
				for(let i = 0; i < this.msgState.length; i++){
					if(this.msgState[i].id == categoryId && this.msgState[i].state == true){
						if(this.msgdelteItem &&  this.msgdelteItem.indexOf(categoryId) > -1){
							if(unreadCount  > 0){
								let i = this.msgdelteItem.indexOf(categoryId);
								this.msgdelteItem.splice(i, 1);//删除 缓存
								localStorage.setItem('msgdelteItem',JSON.stringify(this.msgdelteItem));//删除缓存
								let typeItem = {'categoryId':categoryId,'name':name,'unreadCount':unreadCount,'time':time, "content":content, "code":code};
						        this.msgdata.push(typeItem);
							}
						}else if(this.msgsignUnRead && this.msgsignUnRead.length > 0 && this.msgsignUnRead.indexOf(categoryId) > -1){
							if(unreadCount == 0){
								unreadCount = 1;
							}
							let typeItem = {'categoryId':categoryId,'name':name,'unreadCount':unreadCount,'time':time, "content":content, "code":code};
						    this.msgdata.push(typeItem);
						}else{
							let typeItem = {'categoryId':categoryId,'name':name,'unreadCount':unreadCount,'time':time, "content":content, "code":code};
						    this.msgdata.push(typeItem);
						}
					}
				}
			}else{
				if(this.msgdelteItem &&  this.msgdelteItem.indexOf(categoryId) > -1){
					if(unreadCount  > 0){
						let i = this.msgdelteItem.indexOf(categoryId);
						this.msgdelteItem.splice(i, 1);//删除 缓存
						localStorage.setItem('msgdelteItem',JSON.stringify(this.msgdelteItem));//删除缓存
						let typeItem = {'categoryId':categoryId,'name':name,'unreadCount':unreadCount,'time':time, "content":content, "code":code};
						this.msgdata.push(typeItem);
					}
				}else if(this.msgsignUnRead && this.msgsignUnRead.length > 0 && this.msgsignUnRead.indexOf(categoryId) > -1){
					if(unreadCount == 0){
						unreadCount = 1;
					}
					let typeItem = {'categoryId':categoryId,'name':name,'unreadCount':unreadCount,'time':time, "content":content, "code":code};
					this.msgdata.push(typeItem);
				}else{
					let typeItem = {'categoryId':categoryId,'name':name,'unreadCount':unreadCount,'time':time, "content":content, "code":code};
					this.msgdata.push(typeItem);
				}
			}
		  }
		}
	}


	msgListCallback = (params)=>{
		return new Promise((resolve, reject) => {
			if(typeof(params)!='undefined'){
				resolve('ok');
				this.dataInit();
			}else{
				reject(Error('error'));
			}
   		});
  	}

	//跳转到消息列表
	clickMessage(event:any,item:any){
		if(item != null && item != undefined){
			//清除未读消息缓存
			if(this.msgsignUnRead != null && this.msgsignUnRead.length >0 && this.msgsignUnRead.indexOf(item.categoryId) > -1){
				this.msgsignUnRead.splice(this.msgsignUnRead.indexOf(item.categoryId), 1);
				localStorage.setItem('msgsignUnRead',JSON.stringify(this.msgsignUnRead));//
			  }
			}

			if(item.categoryId == "402880086512366901651238780d0000"){
		      let params = {'username':this.user.xgh};
			  this.httpService.get2(MARK_MSG_BY_CATEGORYID,params).then();
			}

			let param ={"categoryId":item.categoryId, callback: this.msgListCallback, "code":item.code};
			if(item.categoryId == "402880086512366901651238780d0000"){
				this.appCtrl.getRootNav().push(XxtxmsglistPage, param);
			}else if(item.categoryId == "402880086512366901651238b4960001"){
				this.appCtrl.getRootNav().push(WddbmsglistPage, param);
			}
	}

	//跳转消息设置页面
	gotoMsgSettingPage(){
		this.appCtrl.getRootNav().push(MsgSettingPage,{callback: this.msgListCallback});
	}

	//标记未读
	signUnRead(event:any,item:any,index:any,slidingItem:ItemSliding){
		if(this.msgsignUnRead != null && this.msgsignUnRead.constructor ==Array && this.msgsignUnRead.indexOf(item.categoryId) < 0){
			this.msgsignUnRead.push(item.categoryId);
			localStorage.setItem('msgsignUnRead',JSON.stringify(this.msgsignUnRead));
			this.msgdata[index].unreadCount = 1;
		}
		slidingItem.close();
	}

	//标记已读
	signRead(event:any, item:any, index:any, slidingItem:ItemSliding){
		if(item.categoryId == '402880086512366901651238780d0000'){//只有提醒类消息才会回传
           //回传服务器标记已读
		   let params = {'username':this.user.xgh};
		   this.httpService.get2(MARK_MSG_BY_CATEGORYID,params).then();
		}
		  //清理未读标记缓存
		  if(this.msgsignUnRead != null && this.msgsignUnRead.length >0 && this.msgsignUnRead.indexOf(item.categoryId) > -1){
			this.msgsignUnRead.splice(this.msgsignUnRead.indexOf(item.categoryId), 1);
			localStorage.setItem('msgsignUnRead',JSON.stringify(this.msgsignUnRead));//
		  }
		  //本地数据 未读数置0
		  this.msgdata[index].unreadCount = 0;
		slidingItem.close();
	}

	//删除,并清除未读数
	delteItem(event:any,item:any,index:any){
	 	if(this.msgdelteItem &&  this.msgdelteItem.indexOf(item.categoryId) < 0){
			this.msgdelteItem.push(item.categoryId);
			localStorage.setItem('msgdelteItem',JSON.stringify(this.msgdelteItem));
		}

		if(this.msgdata != null && this.msgdata.constructor == Array){//删除本地数据
			for(let i = 0; i < this.msgdata.length; i++){
				if(this.msgdata[i].categoryId == item.categoryId){
					this.msgdata.splice(i, 1);
					break;
				}
			}
		}

		if(item.categoryId == '01'){
		let params = {'username':this.user.xgh};
		this.httpService.get2(MARK_MSG_BY_CATEGORYID,params).then();
		}
	}

	 // 将'2019-01-03T00:18:21.000+0000'这种格式的时间转为正常格式 
	 renderTime(date) {
		if (date) {
			var dateee = new Date(date).toJSON();
			return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '') 
		}
	 }

	 getALabelContent(str) {
		if (str) {
		    return str.replace(/[^\u4e00-\u9fa5]/gi,"");  
		}
		return '';
	 }

}



// WEBPACK FOOTER //
// ./src/pages/message/list/list.ts